type SuccessResult<T> = readonly [T, null];

type ErrorResult<E = Error> = readonly [null, E];

type Result<T, E = Error> = ErrorResult<E> | SuccessResult<T>;

export async function tryCatch<T, E = Error>(promise: Promise<T>): Promise<Result<T, E>> {
  try {
    const data = await promise;

    return [data, null] as const;
  } catch (error) {
    return [null, error as E] as const;
  }
}
